import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { StorageNodeService } from '../storage-node.service'
import { StorageNodeFilterBuilder } from '../storage-node-filter-builder'

@Directive({
  selector: '[appStorageNodeSelect]',
})
export class StorageNodeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const storageNodeService = inject(StorageNodeService)
    this.select.displayProperty = 'path'
    this.select.placeholder = 'shopfloor.storage.location'
    this.select.dataSource = storageNodeService
    this.select.sorts = [new Sort('id', 'asc')]
  }

  @Input()
  public set facilityId(facilityId: string) {
    if (facilityId) {
      this.select.filters = StorageNodeFilterBuilder.start().facility(facilityId).build()
    }
  }
}
